import { apiCall } from "./apiCall";

export default function orderApi() {
  return {
    getDashboardOrders: (data, token) => apiCall("/getOrdersList", data, token),
    getOrdersData: (data, token) => apiCall("/getOrdersList", data, token),
    viewOrders: (data, token) => apiCall("/getOrderById", data, token),
    getCarts: (data, token) => apiCall("/getCartList", data, token),
    addTOCart: (data, token) => apiCall("/addTOCart", data, token),
    deleteCart: (data, token) => apiCall("/deleteCart", data, token),
    create: (data, token) => apiCall("/adminPlaceOrder", data, token),
    exportOrdersDetails: (data, token) =>
      apiCall("/exportOrderKeys", data, token),
    exportAllOrders: (data, token) => apiCall("/exportAllOrders", data, token),
    reprocessOrder: (data, token) => apiCall("/reprocessOrder", data, token),
    devcoOrder: (data, token) => apiCall("/adminPlaceDevcoOrder", data, token),
    epayOrder: (data, token) => apiCall("/adminPlaceEpayOrder", data, token),
  };
}
